module.exports = __webpack_public_path__ + "resources/img/img_cloud_moa4_m.d7f3f63b1e48fe8a4afbe8029188981a.png";